import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TaxrateDto } from '../dtos';
import { ITaxratesFeature } from './taxrate.feature.state';
import { getFailures, getIsLoading, getTaxrates } from './taxrate.selectors';

@Injectable()
export class TaxratesFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);
  public taxrates$ = this.store.select(getTaxrates);

  constructor(private store: Store<ITaxratesFeature>) {}

  public getTaxrateById(taxrateId: number): Observable<TaxrateDto> {
    return this.taxrates$.pipe(map((dictionary) => dictionary[taxrateId]));
  }
}
